// extracted by mini-css-extract-plugin
export default {"Product_page_modal_container":"ProductModalInfo_Product_page_modal_container__hW27C"};